import TextField from '@/components/FormElements/TextField';
import { dybrConfigs } from '@/configs/dybr';

interface NicknameFieldProps {
  nickname: string;
  setNickname: (value: string) => void;
  setErrorNickname: (value: string) => void;
  errorNickname: string;
  validate: () => void;
}

export function NicknameField({
  nickname,
  setNickname,
  setErrorNickname,
  errorNickname,
  validate
}: NicknameFieldProps) {
  return (
    <TextField
      id="nickname"
      type="text"
      value={nickname}
      meta={{}}
      className=""
      maxLen={dybrConfigs.MAX_LENGTH.nickname}
      onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
        setNickname(e.target.value);
        setErrorNickname('');
      }}
      label="никнейм"
      onBlur={validate}
      error={errorNickname}
      touched={Boolean(errorNickname)}
    />
  );
}
